const ONBOARDING_PATH_PREFIX = "/user/onboard";

/**
 * The one onboarding screen a learner may still see after they have finished
 * onboarding. Finishing stops the server returning the onboarding form, so
 * every other screen in the flow loses the data it renders from and can only
 * show its loading state — reaching one via the browser back button leaves
 * the learner on a spinner that nothing will ever resolve.
 */
export const READY_SCREEN_PATH = "/user/onboard/success";

export const isOnboardingPath = (pathname: string): boolean =>
  pathname.startsWith(ONBOARDING_PATH_PREFIX);

// React Router matches a route whether or not the URL carries a trailing
// slash, so the comparison below has to as well — otherwise
// `/user/onboard/success/` renders the ready screen and is redirected away
// from it in the same breath.
const withoutTrailingSlash = (pathname: string): string =>
  pathname.length > 1 ? pathname.replace(/\/+$/, "") : pathname;

interface OnboardingAccess {
  pathname: string;
  shouldOnboard: boolean;
  shouldViewReadyScreen: boolean;
}

export const shouldRedirectOutOfOnboarding = ({
  pathname,
  shouldOnboard,
  shouldViewReadyScreen,
}: OnboardingAccess): boolean =>
  isOnboardingPath(pathname) &&
  !shouldOnboard &&
  !(
    shouldViewReadyScreen &&
    withoutTrailingSlash(pathname) === READY_SCREEN_PATH
  );
